import config from 'config/config'
import React from 'react'
import { Icon, Table } from 'semantic-ui-react'

export default class DiscountedProductRow extends React.Component {
  render() {
    const { product, removeProduct, index } = this.props
    return (
      <Table.Row>
        <Table.Cell width={16}>
          <strong>{product.article_number}</strong>
          <br />
          {product.title_de}
          <br />
          <div className="unobtrusive">{product.title_fr}</div>
        </Table.Cell>
        <Table.Cell textAlign="right">
          <Icon
            {...config.icons.unlink}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              removeProduct(index)
            }}
          />
        </Table.Cell>
      </Table.Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/Discounts/DiscountedProductRow.jsx